/* eslint-disable react/prop-types */
import "./styles.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  ListGroup,
  ListGroupItem,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useState, useEffect, useCallback, useContext } from "react";
import api from "../../../../services/axiosConfig";
import { Context } from "../../../../hooks/useAuthContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { GoDotFill } from "react-icons/go";


function NovoDesconto({ isOpen, toggle, fetchData, mesAno, descontoParaEditar  }) {
  const { exibirLogs } = useContext(Context);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [observation, setObservation] = useState("");
  const [discountValue, setDiscountValue] = useState("")
  const [referenceDate, setReferenceDate] = useState(new Date());
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const isEditMode = !!descontoParaEditar;

   const getAccountTypeColor = (tipoConta) => {
    switch (tipoConta) {
      case 'usuario':
        return 'red';
      case 'influenciador':
        return 'green';
      case 'afiliado':
        return 'blue';
      default:
        return 'inherit'; 
    }
  };
  
  const parseCurrencyToNumber = (brlString) => {
    if (!brlString || typeof brlString !== 'string') {
      return 0;
    }

    const stringWithoutDots = brlString.replace(/\./g, '');
    const standardFormatString = stringWithoutDots.replace(',', '.');
    const numberValue = parseFloat(standardFormatString);

    return isNaN(numberValue) ? 0 : numberValue;
  };

  const fetchUsers = useCallback(async (searchQuery) => {
    if (searchQuery.length < 3) {
      setSearchResults([]);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await api.get("/admin/users", {
        params: {
          search: searchQuery,
          limit: 10,
        },
      });
      setSearchResults(response.data.data || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar usuários:", error);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.length >= 3) {
        fetchUsers(searchTerm);
      } else {
        setSearchResults([]);
      }
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, fetchUsers]);


  useEffect(() => {
    if (isOpen) {
      if (isEditMode) {
        setSelectedUser({
          _id: descontoParaEditar.uid,
          nome: descontoParaEditar.nome,
          apelido: descontoParaEditar.apelido,
          tipoConta: descontoParaEditar.tipoConta,
          cpfCnpj: descontoParaEditar.cpfCnpj
        });
        setSearchTerm(descontoParaEditar.nome);
        setObservation(descontoParaEditar.obs);
        
        const valorString = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2
        }).format(descontoParaEditar.value)

        const valorFormatado = valorString || 0
        setDiscountValue(valorFormatado);
        
        const [mes, ano] = descontoParaEditar.date.split('/');
        setReferenceDate(new Date(parseInt(ano), parseInt(mes) - 1));
        
        setSearchResults([]);
      } else {
        resetForm();
      }
    }
  }, [isOpen, descontoParaEditar, isEditMode]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setSelectedUser(null);
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    setSearchTerm(user.nome);
    setSearchResults([]);
  };


  const handleDiscountValueChange = (e) => {
  const rawValue = e.target.value.replace(/\D/g, '');

  if (rawValue === '' || !rawValue) {
    setDiscountValue('');
    return;
  }
  const numberValue = parseFloat(rawValue) / 100;

  const formattedValue = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
  }).format(numberValue);

  setDiscountValue(formattedValue);
};

  const handleSaveDiscount = async () => {
    if (!selectedUser) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, selecione um usuário.",
      });
      return;
    }
    if (!discountValue || parseFloat(discountValue.replace(",", ".")) <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, insira um valor de desconto válido.",
      });
      return;
    }

    try {
      const mes = String(referenceDate.getMonth() + 1).padStart(2, "0");
      const ano = referenceDate.getFullYear();
      const formattedDate = `${mes}/${ano}`;

      const numericValue = parseCurrencyToNumber(discountValue);

      const payload = {
        uid: selectedUser._id,
        apelido: selectedUser.apelido || null,
        date: formattedDate,
        obs: observation,
        tipoConta: selectedUser.tipoConta,
        value: numericValue,
        nome: selectedUser.nome,
        cpfCnpj: selectedUser.cpfCnpj,
      };

      if (isEditMode) {
        const response = await api.put(`/descontos/atualizar-desconto/${descontoParaEditar._id}`, payload);
        toast.success(response.data.message || "Desconto atualizado com sucesso!");
      } else {
        const response = await api.post("/descontos/criar-desconto", payload);
        toast.success(response.data.message || "Desconto criado com sucesso!");
      }

      resetForm();
      toggle();
      await fetchData(mesAno);
    } catch (error) {
      console.error("Erro ao criar desconto:", error);
      toast.error(error.response?.data?.message || "Erro ao criar desconto");
    }
  };

  const resetForm = () => {
    setSearchTerm("");
    setSelectedUser(null);
    setObservation("");
    setDiscountValue("");
    setReferenceDate(new Date());
    setSearchResults([]);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="new-discount-modal">
      <ModalHeader toggle={toggle} style={{ display: 'flex' }}>
        <div style={{ marginBottom: '-5px' }}>
          {isEditMode ? 'Editar Desconto' : 'Novo desconto'}
        </div>
        <span className="text-muted" style={{ fontSize: 14 }}>
          {isEditMode ? `Editando desconto de ${descontoParaEditar?.nome}` : 'Desconto referente ao mês da campanha'}
        </span>
      </ModalHeader>
      <ModalBody>
        
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, marginBottom: 10}}>
          <span style={{color: 'red'}}><GoDotFill size={15} /> cortador</span>
          <span style={{color: 'green'}}><GoDotFill size={15} /> influenciador</span>
          <span style={{color: 'blue'}}><GoDotFill size={15} /> afiliado</span>
        </div>
        <Form>
          <FormGroup>
            <Label for="searchUser">
              Pesquisar por{" "}
              <span className="small-text">(nome, apelido, cpf, cnpj)</span>
            </Label>
            <Input
              type="text"
              name="searchUser"
              id="searchUser"
              placeholder="João"
              value={searchTerm}
              onChange={handleSearchChange}
              autoComplete="off"
              disabled={isEditMode}
            />
            {!isEditMode && searchTerm.length >= 3 && searchLoading && (
              <p className="search-status">Carregando usuários...</p>
            )}
            {!isEditMode && searchTerm.length >= 3 && !searchLoading && searchResults.length > 0 && !selectedUser && (
              <ListGroup className="user-suggestions">
                {searchResults.map((user) => (
                  <ListGroupItem
                    key={user._id}
                    tag="button"
                    action
                    onClick={() => handleUserSelect(user)}
                    className="user-suggestion-item"
                  >
                    <span style={{ color: getAccountTypeColor(user.tipoConta) }}>{user.nome}{" "} {user.apelido && `(${user.apelido})`}{" "}</span>
                    <span style={{ color: getAccountTypeColor(user.tipoConta) }}>{user.cpfCnpj && `- ${user.cpfCnpj}`}</span>
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}

            {searchTerm.length >= 3 &&
              !searchLoading &&
              searchResults.length === 0 &&
              !selectedUser && (
                <p className="no-users-found">Nenhum usuário encontrado.</p>
              )}
            {selectedUser && (
              <p className="selected-user-display">
                Usuário selecionado: <strong>{selectedUser.nome}</strong>
                <Button
                  close
                  onClick={() => setSelectedUser(null)}
                  className="ml-2"
                />
              </p>
            )}
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="observation">Observação</Label>
            <Input
              type="textarea"
              name="observation"
              id="observation"
              placeholder="Ex:&#10;1.000 - Desconto de premiação&#10;1.000 - Desconto de algo"
              rows="4"
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="discountValue">Total de descontos</Label>
            <InputGroup>
              <InputGroupText>R$</InputGroupText>
              <Input
                type="text"
                name="discountValue"
                id="discountValue"
                value={discountValue}
                onChange={handleDiscountValueChange}
                placeholder="0,00"
                maxLength={12}
              />
            </InputGroup>
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="referenceDate">Mês da campanha</Label>
            <br />
            <DatePicker
              selected={referenceDate}
              onChange={(date) => setReferenceDate(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              locale={ptBR}
              className="form-control"
              id="referenceDate"
              autoComplete="off"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSaveDiscount}>
          {isEditMode ? 'Salvar Alterações' : 'Salvar Desconto'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default NovoDesconto;
